import { ApproveTicketRequest } from "../../../types/request/ticket.request.type";
import { ApproveTicketResponse } from "../../../types/response/ticket.response.type";
import { GET } from "../../../utils/enum/requestMethods.enum";
import { HelpDeskApiRoutes } from "../../../utils/mapping/apiRoutes.mapping";
import { reduxApiService } from "../../services/reduxApi.service";

const approveTicketsApi = reduxApiService.injectEndpoints({
  endpoints: (build) => ({
    approveTicket: build.mutation<ApproveTicketResponse, ApproveTicketRequest>({
      query: (requestParams) => ({
        url: HelpDeskApiRoutes.approveTicket,
        method: GET,
        params: { ...requestParams },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useApproveTicketMutation } = approveTicketsApi;
